import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlineInfoCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0013 18.9583C5.05964 18.9583 1.04297 14.9416 1.04297 9.99996C1.04297 5.05829 5.05964 1.04163 10.0013 1.04163C14.943 1.04163 18.9596 5.05829 18.9596 9.99996C18.9596 14.9416 14.943 18.9583 10.0013 18.9583ZM10.0013 2.29163C5.7513 2.29163 2.29297 5.74996 2.29297 9.99996C2.29297 14.25 5.7513 17.7083 10.0013 17.7083C14.2513 17.7083 17.7096 14.25 17.7096 9.99996C17.7096 5.74996 14.2513 2.29163 10.0013 2.29163Z",
			fill: "#5B7086"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 13.9583C9.65833 13.9583 9.375 13.675 9.375 13.3333V9.16663C9.375 8.82496 9.65833 8.54163 10 8.54163C10.3417 8.54163 10.625 8.82496 10.625 9.16663V13.3333C10.625 13.675 10.3417 13.9583 10 13.9583Z",
			fill: "#5B7086"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0013 7.49587C9.89297 7.49587 9.78464 7.47087 9.68464 7.42921C9.58464 7.38754 9.49297 7.32921 9.40964 7.25421C9.33464 7.17087 9.2763 7.08754 9.23464 6.97921C9.19297 6.87921 9.16797 6.77087 9.16797 6.66254C9.16797 6.55421 9.19297 6.44587 9.23464 6.34587C9.2763 6.24587 9.33464 6.15421 9.40964 6.07087C9.49297 5.99587 9.58464 5.93754 9.68464 5.89587C9.88464 5.81254 10.118 5.81254 10.318 5.89587C10.418 5.93754 10.5096 5.99587 10.593 6.07087C10.668 6.15421 10.7263 6.24587 10.768 6.34587C10.8096 6.44587 10.8346 6.55421 10.8346 6.66254C10.8346 6.77087 10.8096 6.87921 10.768 6.97921C10.7263 7.08754 10.668 7.17087 10.593 7.25421C10.5096 7.32921 10.418 7.38754 10.318 7.42921C10.218 7.47087 10.1096 7.49587 10.0013 7.49587Z",
			fill: "#5B7086"
		})
	]
});
export default SvgOutlineInfoCircle;
